import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { CLIP_ENDS } from './types';

const payloadSchema = Joi.object().keys({
  channelID: Joi.string(),
  episodeID: Joi.string(),
  clipID: Joi.string(),
  programTimelineID: Joi.string(),
});

const clipEnds = actionCreator(CLIP_ENDS, payloadSchema);

export const clipEndsAction = (payload) => (dispatch, getState) => {
  const state = getState();
  if (!state.player.clipIsOver) {
    return dispatch(clipEnds(payload));
  }
  return undefined;
};
